(function () {
  "use strict";

  var root = document.querySelector("[data-drsknn-paid-v3]");
  if (!root || root.getAttribute("data-paid-v3-ready") === "true") return;
  root.setAttribute("data-paid-v3-ready", "true");
  document.documentElement.classList.add("drsknn-paid-v3-route");
  document.body.classList.add("drsknn-paid-v3-route");

  var ATTRIBUTION_KEYS = [
    "gclid", "gbraid", "wbraid", "msclkid", "utm_source", "utm_medium",
    "utm_campaign", "utm_term", "utm_content", "fbclid", "ttclid"
  ];
  var proofItems = [];
  var proofModalIndex = 0;
  var proofModalOpener = null;
  var detailModalOpener = null;
  var treatmentPickerOpener = null;
  var treatmentPickerPlaceholder = null;
  var treatmentPickerInertState = [];
  var treatmentPickerScrollPosition = null;
  var reviewState = {
    active: "all",
    google: [],
    pabau: [],
    googleTotal: 0,
    pabauTotal: 0,
    googleComplete: false,
    pabauComplete: false
  };
  var reviewLayoutFrame = 0;
  var reviewLayoutObserver = null;
  var reviewLayoutObservedWidth = null;
  var reviewLayoutPaused = false;
  var visitPlannerEnabled = root.getAttribute("data-visit-planner-enabled") === "true";
  var visitStorageKey = "drsknn_pricing_v3_visit";
  var visitMaxItems = Math.max(1, Math.min(10, Number(root.getAttribute("data-visit-planner-max")) || 10));
  var visitSelections = [];
  var visitCatalogue = null;
  var visitCataloguePromise = null;
  var visitReturnFocus = null;
  var visitNoticeTimer = 0;
  var visitUndoId = "";
  var visitAddGesture = null;
  var visitSuppressedButton = null;
  var visitSuppressedUntil = 0;
  var VISIT_HANDOFF_MAX_URL = 7000;
  var VISIT_SAFE_FAMILY_KEYS = {
    dermalfillers: true,
    co2: true,
    chemicalpeel: true,
    hifu: true,
    hydrafacial: true,
    ipl: true,
    onda: true,
    dermalux: true,
    hairreduction: true
  };
  var VISIT_CONCERNS = [
    { label: "Facial shape or volume", family: "dermalfillers" },
    { label: "Skin texture or scarring", family: "co2" },
    { label: "Dull or congested skin", family: "hydrafacial" },
    { label: "Pigmentation or redness", family: "ipl" },
    { label: "Firmness or laxity", family: "hifu" },
    { label: "Body contouring", family: "onda" },
    { label: "Unwanted hair", family: "hairreduction" },
    { label: "Gentle skin support", family: "dermalux" },
    { label: "Skin refresh", family: "chemicalpeel" }
  ];

  function select(selector, context) {
    return (context || root).querySelector(selector);
  }

  function selectAll(selector, context) {
    return Array.prototype.slice.call((context || root).querySelectorAll(selector));
  }

  function clean(value, maxLength) {
    return String(value == null ? "" : value)
      .replace(/[\u0000-\u001F\u007F]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLength || 1200);
  }

  function configuredText(attribute, fallback, maxLength) {
    return clean(root.getAttribute(attribute), maxLength || 240) || fallback;
  }

  function configuredList(attribute, fallback) {
    var source = configuredText(attribute, fallback.join("|"), 2400);
    return source.split("|").map(function (value) {
      return clean(value, 120).toLowerCase().replace(/_/g, "-");
    }).filter(function (value, index, values) {
      return value && policySafe(value) && values.indexOf(value) === index;
    });
  }

  function decodedPolicyTokens() {
    return [
      [98, 111, 116, 111, 120],
      [98, 111, 116, 117, 108, 105, 110, 117, 109],
      [97, 122, 122, 97, 108, 117, 114, 101],
      [98, 111, 99, 111, 117, 116, 117, 114, 101],
      [100, 121, 115, 112, 111, 114, 116],
      [97, 108, 108, 117, 122, 105, 101, 110, 99, 101],
      [112, 114, 111, 102, 104, 105, 108, 111],
      [112, 111, 108, 121, 110, 117, 99, 108, 101, 111, 116, 105, 100, 101],
      [101, 120, 111, 115, 111, 109, 101],
      [112, 117, 114, 97, 115, 111, 109, 101],
      [110, 99, 116, 102],
      [109, 104, 97, 49, 48],
      [105, 110, 106, 101, 99, 116, 105, 111, 110],
      [112, 114, 112],
      [112, 114, 102],
      [112, 108, 97, 116, 101, 108, 101, 116, 32, 114, 105, 99, 104],
      [104, 97, 105, 114, 32, 114, 101, 103, 114, 111, 119, 116, 104]
    ].map(function (codes) {
      return String.fromCharCode.apply(String, codes);
    });
  }

  var POLICY_TOKENS = decodedPolicyTokens();

  function policyNormal(value) {
    return clean(value, 24000)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "");
  }

  function policySafe(value) {
    var comparable = policyNormal(value);
    if (!comparable) return true;
    return !POLICY_TOKENS.some(function (token) {
      return comparable.indexOf(policyNormal(token)) !== -1;
    });
  }

  function safeHttpsUrl(value) {
    var url;
    try {
      url = new URL(clean(value, 2200), window.location.origin);
    } catch (_) {
      return "";
    }
    if (url.protocol !== "https:") return "";
    if (!policySafe(url.href)) return "";
    var hostname = url.hostname.toLowerCase();
    var allowed = ["ucarecdn.com", "cdn.shopify.com", "drsknn.com", "www.drsknn.com"];
    if (!allowed.some(function (domain) { return hostname === domain || hostname.slice(-(domain.length + 1)) === "." + domain; })) return "";
    return url.href;
  }

  function readAttribution() {
    var params = new URLSearchParams(window.location.search || "");
    var values = {};
    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = clean(params.get(key), 300);
      if (!value) return;
      values[key] = value;
    });
    return values;
  }

  function decorateTrackedUrl(value) {
    var decorated = value;
    try {
      if (
        window.DRSKNN_ATTRIBUTION &&
        typeof window.DRSKNN_ATTRIBUTION.decorateUrl === "function"
      ) {
        decorated = window.DRSKNN_ATTRIBUTION.decorateUrl(decorated) || decorated;
      }
    } catch (_) {}
    var url;
    try { url = new URL(decorated, window.location.href); } catch (_) { return ""; }
    var attribution = readAttribution();
    Object.keys(attribution).forEach(function (key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, attribution[key]);
    });
    return url.toString();
  }

  function decorateAttributionLinks() {
    selectAll("[data-paid-v3-attribution-link]").forEach(function (link) {
      var url;
      try { url = new URL(decorateTrackedUrl(link.href), window.location.href); } catch (_) { return; }
      if (link.hasAttribute("data-paid-v3-pricing-link")) {
        url.searchParams.set("return_url", window.location.href);
      }
      link.href = url.href;
    });
  }

  function makeElement(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function setAttributes(node, attributes) {
    Object.keys(attributes || {}).forEach(function (name) {
      node.setAttribute(name, String(attributes[name]));
    });
    return node;
  }

  function appendChildren(node, children) {
    children.forEach(function (child) { if (child) node.appendChild(child); });
    return node;
  }

  function focusableElements(container) {
    return selectAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (element) {
      return element.getAttribute("aria-hidden") !== "true" &&
        (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0);
    });
  }

  function trapModalFocus(event, modal) {
    if (!modal || event.key !== "Tab") return;
    var dialog = select('[role="dialog"]', modal);
    if (!dialog) return;
    var focusable = focusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus({ preventScroll: true });
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    if (event.shiftKey && (active === first || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && (active === last || active === dialog || !dialog.contains(active))) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  function syncModalState() {
    var detailModal = select("[data-paid-v3-detail-modal]");
    var proofModal = select("[data-paid-v3-proof-modal]");
    var treatmentPicker = select("[data-paid-v3-treatment-picker]");
    var visitModal = document.querySelector("[data-paid-v3-visit-modal]");
    var visitBrowser = document.querySelector("[data-paid-v3-visit-browser]");
    var isOpen = Boolean(
      (detailModal && !detailModal.hidden) ||
      (proofModal && !proofModal.hidden) ||
      (treatmentPicker && !treatmentPicker.hidden) ||
      (visitModal && !visitModal.hidden) ||
      (visitBrowser && !visitBrowser.hidden)
    );
    document.body.classList.toggle("paid-v3-modal-open", isOpen);
  }

  function openDetailModal(trigger) {
    var modal = select("[data-paid-v3-detail-modal]");
    if (!modal || !trigger) return;
    closeTreatmentPicker(false);
    var proofModal = select("[data-paid-v3-proof-modal]");
    if (proofModal && !proofModal.hidden) closeProofModal(false);
    var eyebrow = select("[data-paid-v3-detail-modal-eyebrow]", modal);
    var title = select("[data-paid-v3-detail-modal-title]", modal);
    var copy = select("[data-paid-v3-detail-modal-copy]", modal);
    if (eyebrow) eyebrow.textContent = clean(trigger.getAttribute("data-paid-v3-detail-eyebrow"), 120) || "More information";
    if (title) title.textContent = clean(trigger.getAttribute("data-paid-v3-detail-title"), 180) || "Clinical planning";
    if (copy) copy.textContent = clean(trigger.getAttribute("data-paid-v3-detail-copy"), 1400) || "Your clinician will explain this during consultation.";
    detailModalOpener = trigger;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    syncModalState();
    var dialog = select('[role="dialog"]', modal);
    if (dialog) dialog.focus({ preventScroll: true });
  }

  function closeDetailModal(restoreFocus) {
    var modal = select("[data-paid-v3-detail-modal]");
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    syncModalState();
    if (restoreFocus !== false && detailModalOpener && typeof detailModalOpener.focus === "function") {
      detailModalOpener.focus({ preventScroll: true });
    }
    detailModalOpener = null;
  }

  function ensureTreatmentPickerUi() {
    if (!visitPlannerEnabled) return null;
    var existing = select("[data-paid-v3-treatment-picker]");
    if (existing) return existing;

    var heading = appendChildren(makeElement("div"), [
      makeElement("span", "", "Exact treatment options"),
      setAttributes(makeElement("h2", "", "Choose your treatment"), {
        id: "paid-v3-treatment-picker-title"
      })
    ]);
    var close = setAttributes(makeElement("button", "", "×"), {
      type: "button",
      "data-paid-v3-treatment-picker-close": "",
      "aria-label": "Close treatment options"
    });
    var header = appendChildren(makeElement("header"), [heading, close]);
    var intro = setAttributes(makeElement(
      "p",
      "paid-v3-treatment-picker__intro",
      "Book one exact option now or add it to My Visit. The complete pricing section remains available further down this page."
    ), { id: "paid-v3-treatment-picker-copy" });
    var slot = setAttributes(makeElement("div", "paid-v3-treatment-picker__slot"), {
      "data-paid-v3-treatment-picker-slot": ""
    });
    var body = appendChildren(makeElement("div", "paid-v3-treatment-picker__body"), [intro, slot]);
    var viewFull = setAttributes(makeElement("button", "paid-v3-button paid-v3-button--quiet", "View full pricing on page"), {
      type: "button",
      "data-paid-v3-treatment-picker-view-full": ""
    });
    var done = setAttributes(makeElement("button", "paid-v3-button paid-v3-button--primary", "Close"), {
      type: "button",
      "data-paid-v3-treatment-picker-close": ""
    });
    var footer = appendChildren(makeElement("footer"), [viewFull, done]);
    var dialog = appendChildren(setAttributes(makeElement("section", "paid-v3-treatment-picker__dialog"), {
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "paid-v3-treatment-picker-title",
      "aria-describedby": "paid-v3-treatment-picker-copy",
      tabindex: "-1"
    }), [header, body, footer]);
    var backdrop = setAttributes(makeElement("div", "paid-v3-treatment-picker__backdrop"), {
      "data-paid-v3-treatment-picker-close": ""
    });
    var overlay = appendChildren(setAttributes(makeElement("div", "paid-v3-treatment-picker"), {
      id: "paid-v3-treatment-picker",
      "data-paid-v3-treatment-picker": "",
      "aria-hidden": "true"
    }), [backdrop, dialog]);
    overlay.hidden = true;
    root.appendChild(overlay);
    return overlay;
  }

  function restoreTreatmentPricing() {
    var modal = select("[data-paid-v3-treatment-picker]");
    var board = modal && select("[data-paid-v3-pricing-module]", modal);
    if (!board) return;
    if (treatmentPickerPlaceholder && treatmentPickerPlaceholder.parentNode) {
      treatmentPickerPlaceholder.parentNode.insertBefore(board, treatmentPickerPlaceholder);
      treatmentPickerPlaceholder.remove();
    } else {
      var panel = select("#paid-v3-pricing .paid-v3-pricing__panel");
      if (panel) panel.appendChild(board);
    }
    treatmentPickerPlaceholder = null;
  }

  function setTreatmentPickerBackgroundInert(modal, enabled) {
    if (enabled) {
      if (treatmentPickerInertState.length) return;
      treatmentPickerInertState = Array.prototype.slice.call(root.children).filter(function (node) {
        return node !== modal;
      }).map(function (node) {
        var state = { node: node, inert: node.hasAttribute("inert") };
        node.setAttribute("inert", "");
        return state;
      });
      return;
    }
    treatmentPickerInertState.forEach(function (state) {
      if (state.node && state.node.isConnected && !state.inert) state.node.removeAttribute("inert");
    });
    treatmentPickerInertState = [];
  }

  function applyTreatmentPickerScroll(position) {
    if (!position) return;
    var documentElement = document.documentElement;
    var previousScrollBehavior = documentElement.style.scrollBehavior;
    documentElement.style.scrollBehavior = "auto";
    window.scrollTo({ left: position.x, top: position.y, behavior: "auto" });
    documentElement.style.scrollBehavior = previousScrollBehavior;
  }

  function restoreTreatmentPickerScroll() {
    if (!treatmentPickerScrollPosition) return;
    var position = treatmentPickerScrollPosition;
    treatmentPickerScrollPosition = null;
    applyTreatmentPickerScroll(position);
  }

  function openTreatmentPicker(trigger) {
    if (!visitPlannerEnabled || !trigger) return false;
    var board = select("[data-paid-v3-pricing-module]");
    var modal = ensureTreatmentPickerUi();
    var slot = modal && select("[data-paid-v3-treatment-picker-slot]", modal);
    if (!board || !modal || !slot) return false;
    if (!modal.hidden) return true;

    var detail = select("[data-paid-v3-detail-modal]");
    var proof = select("[data-paid-v3-proof-modal]");
    if (detail && !detail.hidden) closeDetailModal(false);
    if (proof && !proof.hidden) closeProofModal(false);
    closeVisitBrowser(false);
    closeVisitModal(false);

    var boardRect = board.getBoundingClientRect();
    var boardStyle = window.getComputedStyle(board);
    treatmentPickerScrollPosition = { x: window.scrollX, y: window.scrollY };
    treatmentPickerPlaceholder = setAttributes(makeElement("div", "paid-v3-treatment-picker__placeholder"), {
      "aria-hidden": "true"
    });
    treatmentPickerPlaceholder.style.height = Math.max(0, Math.round(boardRect.height)) + "px";
    treatmentPickerPlaceholder.style.marginTop = boardStyle.marginTop;
    treatmentPickerPlaceholder.style.marginBottom = boardStyle.marginBottom;
    board.parentNode.insertBefore(treatmentPickerPlaceholder, board);
    slot.appendChild(board);

    treatmentPickerOpener = trigger;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    setTreatmentPickerBackgroundInert(modal, true);
    syncVisitButtons();
    syncModalState();
    var close = select("button[data-paid-v3-treatment-picker-close]", modal);
    applyTreatmentPickerScroll(treatmentPickerScrollPosition);
    if (close) close.focus({ preventScroll: true });
    window.requestAnimationFrame(function () {
      if (modal.hidden) return;
      applyTreatmentPickerScroll(treatmentPickerScrollPosition);
      if (close) close.focus({ preventScroll: true });
    });
    return true;
  }

  function closeTreatmentPicker(restoreFocus) {
    var modal = select("[data-paid-v3-treatment-picker]");
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    restoreTreatmentPricing();
    setTreatmentPickerBackgroundInert(modal, false);
    syncModalState();
    restoreTreatmentPickerScroll();
    if (restoreFocus !== false && treatmentPickerOpener && treatmentPickerOpener.isConnected) {
      try { treatmentPickerOpener.focus({ preventScroll: true }); } catch (_) { treatmentPickerOpener.focus(); }
    }
    treatmentPickerOpener = null;
  }

  function viewFullPricingOnPage() {
    var section = select("#paid-v3-pricing");
    closeTreatmentPicker(false);
    treatmentPickerOpener = null;
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function projectedProofItems() {
    var projection = window.DRSKNN_PAID_V3_PROOF;
    var legacyProjectionName = configuredText("data-proof-legacy-global", "", 120);
    if (!projection && legacyProjectionName) projection = window[legacyProjectionName];
    var raw = Array.isArray(projection) ? projection : projection && Array.isArray(projection.items) ? projection.items : [];
    var configuredLimit = Number(root.getAttribute("data-proof-limit"));
    var limit = Math.max(1, Number.isFinite(configuredLimit) && configuredLimit > 0 ? Math.floor(configuredLimit) : raw.length || 18);
    var idPrefix = configuredText("data-proof-id-prefix", "patient-result", 80);
    var fallbackAlt = configuredText("data-proof-fallback-alt", "Dr Sknn before and after patient result", 180);
    var fallbackCaption = configuredText("data-proof-fallback-caption", "Real Dr Sknn patient result. Individual outcomes vary.", 240);
    var seen = {};
    return raw.map(function (item, index) {
      if (!item || typeof item !== "object") return null;
      var src = safeHttpsUrl(item.src || item.poster || item.original);
      if (!src || seen[src]) return null;
      seen[src] = true;
      var alt = policySafe(item.alt) ? clean(item.alt, 180) : "";
      var caption = policySafe(item.caption) ? clean(item.caption, 240) : "";
      var id = policySafe(item.id) ? clean(item.id, 100) : "";
      return {
        id: id || idPrefix + "-" + (index + 1),
        src: src,
        alt: alt || fallbackAlt,
        caption: caption || fallbackCaption
      };
    }).filter(Boolean).slice(0, limit);
  }

  function configuredProofTotal() {
    var total = Number(root.getAttribute("data-proof-total-count"));
    if (!Number.isFinite(total) || total < 0) {
      total = Number(root.getAttribute("data-proof-fallback-count"));
    }
    if (!Number.isFinite(total) || total < 0) total = 0;
    return Math.floor(total);
  }

  function effectiveProofTotal() {
    return Math.max(configuredProofTotal(), proofItems.length);
  }

  function updateProofCounts() {
    var shown = proofItems.length;
    var total = effectiveProofTotal();
    selectAll("[data-paid-v3-proof-shown-count]").forEach(function (node) {
      node.textContent = String(shown);
    });
    selectAll("[data-paid-v3-proof-total-count]").forEach(function (node) {
      node.textContent = String(total);
    });
  }

  function proofProgressText(first, last) {
    var shown = proofItems.length;
    var total = effectiveProofTotal();
    var label = first === last ? String(first) : first + "–" + last;
    label += " of " + shown + " shown";
    if (total > shown) label += " · " + total + " total";
    return label;
  }

  function renderProof() {
    var track = select("[data-paid-v3-proof-track]");
    if (!track) return;
    proofItems = projectedProofItems();
    track.replaceChildren();
    updateProofCounts();

    if (!proofItems.length) {
      var status = makeElement("div", "paid-v3-proof__loading");
      status.setAttribute("role", "status");
      status.appendChild(makeElement("strong", "", configuredText("data-proof-empty-title", "The treatment-specific results are temporarily unavailable.", 220)));
      status.appendChild(makeElement("span", "", configuredText("data-proof-empty-copy", "You can still open the complete Before & After Studio or continue to consultation.", 300)));
      track.appendChild(status);
      updateProofPosition();
      return;
    }

    proofItems.forEach(function (item, index) {
      var figure = makeElement("figure", "paid-v3-proof-card");
      figure.setAttribute("data-paid-v3-proof-card", "");
      figure.setAttribute("data-proof-index", String(index));
      var button = makeElement("button");
      button.type = "button";
      button.setAttribute("aria-label", "Enlarge result " + (index + 1) + " of " + proofItems.length + " shown from " + effectiveProofTotal() + " centrally managed cases");
      button.setAttribute("data-paid-v3-proof-open", String(index));
      var media = makeElement("span", "paid-v3-proof-card__media");
      var image = document.createElement("img");
      image.src = item.src;
      image.alt = item.alt;
      image.loading = index < 2 ? "eager" : "lazy";
      image.decoding = "async";
      image.width = 760;
      image.height = 760;
      media.appendChild(image);
      media.appendChild(makeElement("span", "", configuredText("data-proof-enlarge-label", "Tap to enlarge", 80)));
      var caption = document.createElement("figcaption");
      caption.appendChild(makeElement("strong", "", configuredText("data-proof-card-title", "Patient result", 120)));
      caption.appendChild(makeElement("span", "", item.caption));
      button.appendChild(media);
      button.appendChild(caption);
      figure.appendChild(button);
      track.appendChild(figure);
    });
    updateProofPosition();
  }

  function visibleProofCount() {
    return window.matchMedia("(max-width: 820px)").matches ? 2 : window.matchMedia("(max-width: 1100px)").matches ? 3 : 4;
  }

  function updateProofPosition() {
    var viewport = select("[data-paid-v3-proof-viewport]");
    var position = select("[data-paid-v3-proof-position]");
    if (!viewport || !position) return;
    if (!proofItems.length) {
      position.textContent = "No treatment-specific cases";
      return;
    }
    var cards = selectAll("[data-paid-v3-proof-card]");
    var first = 0;
    if (cards.length > 1) {
      var step = Math.max(1, cards[1].offsetLeft - cards[0].offsetLeft);
      first = Math.max(0, Math.min(cards.length - 1, Math.round(viewport.scrollLeft / step)));
    }
    var last = Math.min(proofItems.length, first + visibleProofCount());
    position.textContent = proofProgressText(first + 1, last);
  }

  function scrollProof(direction) {
    var viewport = select("[data-paid-v3-proof-viewport]");
    var cards = selectAll("[data-paid-v3-proof-card]");
    if (!viewport || !cards.length) return;
    var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : viewport.clientWidth;
    var numberToMove = visibleProofCount() === 2 ? 2 : visibleProofCount();
    viewport.scrollBy({ left: direction * step * numberToMove, behavior: "smooth" });
  }

  function setProofModal(index) {
    if (!proofItems.length) return;
    proofModalIndex = (index + proofItems.length) % proofItems.length;
    var item = proofItems[proofModalIndex];
    var image = select("[data-paid-v3-proof-modal-image]");
    var title = select("[data-paid-v3-proof-modal-title]");
    var caption = select("[data-paid-v3-proof-modal-caption]");
    var position = select("[data-paid-v3-proof-modal-position]");
    if (image) {
      image.src = item.src;
      image.alt = item.alt;
    }
    if (title) title.textContent = configuredText("data-proof-card-title", "Patient result", 120);
    if (caption) caption.textContent = item.caption;
    if (position) position.textContent = proofProgressText(proofModalIndex + 1, proofModalIndex + 1);
  }

  function openProofModal(index, opener) {
    var modal = select("[data-paid-v3-proof-modal]");
    if (!modal || !proofItems.length) return;
    closeTreatmentPicker(false);
    var detailModal = select("[data-paid-v3-detail-modal]");
    if (detailModal && !detailModal.hidden) closeDetailModal(false);
    proofModalOpener = opener || document.activeElement;
    setProofModal(index);
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    syncModalState();
    var close = select("button[data-paid-v3-proof-close]", modal);
    if (close) close.focus();
  }

  function closeProofModal(restoreFocus) {
    var modal = select("[data-paid-v3-proof-modal]");
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    syncModalState();
    if (restoreFocus !== false && proofModalOpener && typeof proofModalOpener.focus === "function") {
      proofModalOpener.focus({ preventScroll: true });
    }
    proofModalOpener = null;
  }

  function flattenedTags(review) {
    var tags = review && review.tags && typeof review.tags === "object" ? review.tags : {};
    return Object.keys(tags).reduce(function (all, key) {
      var values = Array.isArray(tags[key]) ? tags[key] : [tags[key]];
      return all.concat(values.map(function (value) { return clean(value, 80).toLowerCase(); }));
    }, []);
  }

  function reviewNormal(value) {
    return " " + clean(value, 4000)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim() + " ";
  }

  function containsConfiguredKeyword(haystack, keyword) {
    var needle = reviewNormal(keyword);
    return needle.trim() && haystack.indexOf(needle) !== -1;
  }

  function reviewIsRelevant(review) {
    var keywords = configuredList("data-review-keywords", []);
    var haystack = reviewNormal(flattenedTags(review).join(" ") + " " + clean(review.text || review.comment, 1600));
    return keywords.some(function (keyword) { return containsConfiguredKeyword(haystack, keyword); });
  }

  function reviewIsGeneric(review) {
    var exclusions = configuredList("data-review-exclude-keywords", []);
    var text = reviewNormal(review.text || review.comment);
    return !exclusions.some(function (keyword) { return containsConfiguredKeyword(text, keyword); });
  }

  function normaliseReview(review, source, index) {
    if (!review || typeof review !== "object") return null;
    var text = clean(review.text || review.comment, 1400);
    var author = clean(review.author || review.author_name || review.reviewer, 80);
    var date = clean(review.date || review.relative_time_description || review.update_time, 80);
    if (!text || !policySafe(text) || !policySafe(author) || !policySafe(date)) return null;
    var rating = Math.round(Number(review.rating || 5));
    rating = Math.max(1, Math.min(5, rating));
    return {
      id: clean(review.id || source + "-" + index, 120),
      source: source,
      author: author || (source === "pabau" ? "Verified Pabau patient" : "Google reviewer"),
      date: date,
      rating: rating,
      text: text,
      relevant: reviewIsRelevant(review),
      generic: reviewIsGeneric(review)
    };
  }

  function fetchJson(url, timeoutMs) {
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, timeoutMs);
    return fetch(url, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      headers: { Accept: "application/json" },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error("Review source returned " + response.status);
      return response.json();
    }).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function loadGoogleReviews() {
    var primary = clean(root.getAttribute("data-google-reviews-endpoint"), 1800);
    var fallback = clean(root.getAttribute("data-google-reviews-fallback"), 1800);
    return fetchJson(primary, 9000).catch(function () {
      if (!fallback) throw new Error("Google review fallback is unavailable");
      return fetchJson(fallback, 9000);
    }).then(function (payload) {
      var raw = payload && Array.isArray(payload.reviews) ? payload.reviews : payload && payload.place && Array.isArray(payload.place.reviews) ? payload.place.reviews : [];
      reviewState.google = raw.map(function (review, index) { return normaliseReview(review, "google", index); }).filter(Boolean);
      reviewState.googleTotal = Number(payload.rating_count || payload.total || (payload.place && (payload.place.user_rating_count || payload.place.user_ratings_total)) || raw.length || 0);
      reviewState.googleComplete = true;
      renderReviews();
    }).catch(function () {
      reviewState.googleComplete = true;
      renderReviews();
    });
  }

  function loadPabauReviews() {
    var endpoint = clean(root.getAttribute("data-pabau-reviews-endpoint"), 1800);
    return fetchJson(endpoint, 26000).then(function (payload) {
      var raw = payload && Array.isArray(payload.reviews) ? payload.reviews : [];
      reviewState.pabau = raw.map(function (review, index) { return normaliseReview(review, "pabau", index); }).filter(Boolean);
      reviewState.pabauTotal = Number(payload.total || payload.total_count || raw.length || 0);
      reviewState.pabauComplete = true;
      renderReviews();
    }).catch(function () {
      reviewState.pabauComplete = true;
      renderReviews();
    });
  }

  function balancedReviews(reviews, limit) {
    if (reviewState.active !== "all") return reviews.slice(0, limit);
    var google = reviews.filter(function (review) { return review.source === "google"; });
    var pabau = reviews.filter(function (review) { return review.source === "pabau"; });
    var output = [];
    while (output.length < limit && (google.length || pabau.length)) {
      if (pabau.length) output.push(pabau.shift());
      if (output.length < limit && google.length) output.push(google.shift());
    }
    return output;
  }

  function availableReviews() {
    var reviews = reviewState.google.concat(reviewState.pabau);
    if (reviewState.active === "google") reviews = reviewState.google.slice();
    if (reviewState.active === "pabau") reviews = reviewState.pabau.slice();
    var relevant = reviews.filter(function (review) { return review.relevant; });
    var safeFallback = reviews.filter(function (review) { return !review.relevant && review.generic; });
    return balancedReviews(relevant.concat(safeFallback), 6);
  }

  function reviewCard(review) {
    var article = makeElement("article", "paid-v3-review-card");
    article.setAttribute("data-paid-v3-review-card", review.source);
    var source = makeElement("div", "paid-v3-review-card__source");
    source.appendChild(makeElement("span", "", review.source === "pabau" ? "Pabau · verified appointment" : "Google · public review"));
    var stars = makeElement("span", "paid-v3-review-card__stars", "★★★★★".slice(0, review.rating));
    stars.setAttribute("aria-label", review.rating + " out of 5 stars");
    source.appendChild(stars);
    article.appendChild(source);
    var quote = document.createElement("blockquote");
    quote.textContent = "“" + review.text + "”";
    article.appendChild(quote);
    var footer = document.createElement("footer");
    var person = document.createElement("div");
    person.appendChild(makeElement("strong", "", review.author));
    person.appendChild(makeElement("span", "", review.date || (review.source === "pabau" ? "Verified appointment feedback" : "Google Business Profile")));
    footer.appendChild(person);
    footer.appendChild(makeElement(
      "span",
      "",
      review.relevant
        ? configuredText("data-review-relevant-label", "Relevant experience", 80)
        : configuredText("data-review-generic-label", "Clinic experience", 80)
    ));
    article.appendChild(footer);
    return article;
  }

  function updateReviewSummaries() {
    var googleText = reviewState.googleTotal ? reviewState.googleTotal + " public reviews" : "Live patient feedback";
    var pabauText = reviewState.pabauTotal ? reviewState.pabauTotal + " verified reviews" : "Verified appointments";
    selectAll("[data-paid-v3-google-summary]").forEach(function (node) { node.textContent = googleText; });
    selectAll("[data-paid-v3-pabau-summary]").forEach(function (node) { node.textContent = pabauText; });
  }

  // A horizontal grid's shared row follows its longest review. Size the mobile
  // viewport to the active card without shortening or changing any review text.
  function syncReviewLayout() {
    reviewLayoutFrame = 0;
    if (reviewLayoutPaused) return;
    var grid = select("[data-paid-v3-review-grid]");
    if (!grid || !grid.isConnected) return;
    if (!window.matchMedia("(max-width: 560px)").matches) {
      grid.style.removeProperty("height");
      return;
    }
    var cards = selectAll("[data-paid-v3-review-card]", grid);
    if (!cards.length || grid.clientWidth < 1) {
      grid.style.removeProperty("height");
      return;
    }
    var styles = window.getComputedStyle(grid);
    var leftPadding = parseFloat(styles.paddingLeft) || 0;
    var topPadding = parseFloat(styles.paddingTop) || 0;
    var bottomPadding = parseFloat(styles.paddingBottom) || 0;
    var start = grid.getBoundingClientRect().left + grid.clientLeft + leftPadding;
    var active = null;
    var nearest = Infinity;
    cards.forEach(function (card) {
      var bounds = card.getBoundingClientRect();
      if (bounds.width < 1 || bounds.height < 1) return;
      var distance = Math.abs(bounds.left - start);
      if (distance < nearest) { nearest = distance; active = bounds; }
    });
    if (!active) { grid.style.removeProperty("height"); return; }
    // offsetHeight - clientHeight includes borders and any non-overlay horizontal scrollbar.
    var chrome = Math.max(0, grid.offsetHeight - grid.clientHeight);
    var height = Math.ceil(active.height + topPadding + bottomPadding + chrome);
    if (grid.style.height !== height + "px") grid.style.height = height + "px";
    // Offscreen longer cards must not leave a prior vertical scroll offset behind.
    if (grid.scrollTop) grid.scrollTop = 0;
  }

  function scheduleReviewLayout() {
    if (reviewLayoutPaused || reviewLayoutFrame) return;
    reviewLayoutFrame = window.requestAnimationFrame(syncReviewLayout);
  }

  function observeReviewLayout() {
    if (reviewLayoutObserver) reviewLayoutObserver.disconnect();
    reviewLayoutObserver = null;
    reviewLayoutObservedWidth = null;
    if (reviewLayoutPaused) return;
    var grid = select("[data-paid-v3-review-grid]");
    if (!grid) return;
    if (typeof window.ResizeObserver === "function") {
      reviewLayoutObserver = new window.ResizeObserver(function (entries) {
        var needsMeasure = false;
        entries.forEach(function (entry) {
          if (entry.target === grid) {
            var width = entry.contentRect.width;
            if (reviewLayoutObservedWidth === null || Math.abs(width - reviewLayoutObservedWidth) > 0.5) {
              reviewLayoutObservedWidth = width;
              needsMeasure = true;
            }
          } else {
            // Card heights can change after fonts load or text is enlarged.
            needsMeasure = true;
          }
        });
        if (needsMeasure) scheduleReviewLayout();
      });
      reviewLayoutObserver.observe(grid);
      selectAll("[data-paid-v3-review-card]", grid).forEach(function (card) {
        reviewLayoutObserver.observe(card);
      });
    }
    scheduleReviewLayout();
  }

  function pauseReviewLayout() {
    reviewLayoutPaused = true;
    if (reviewLayoutFrame) window.cancelAnimationFrame(reviewLayoutFrame);
    reviewLayoutFrame = 0;
    if (reviewLayoutObserver) reviewLayoutObserver.disconnect();
  }

  function resumeReviewLayout() {
    reviewLayoutPaused = false;
    observeReviewLayout();
  }

  function renderReviews() {
    var grid = select("[data-paid-v3-review-grid]");
    var status = select("[data-paid-v3-review-status]");
    if (!grid) return;
    updateReviewSummaries();
    var reviews = availableReviews();
    grid.replaceChildren();
    if (reviews.length) {
      reviews.forEach(function (review) { grid.appendChild(reviewCard(review)); });
      observeReviewLayout();
      if (status) {
        var sourceLabel = reviewState.active === "all" ? "Google and verified Pabau" : reviewState.active === "google" ? "Google" : "verified Pabau";
        status.textContent = "Showing current policy-safe feedback from " + sourceLabel + ".";
      }
      return;
    }

    var finished = reviewState.googleComplete && reviewState.pabauComplete;
    var message = makeElement("div", "paid-v3-review-status", finished ? "Live reviews are temporarily unavailable here. Open either verified source using the links below." : "Loading current patient feedback…");
    message.setAttribute("role", "status");
    grid.appendChild(message);
    observeReviewLayout();
    if (status) status.textContent = finished ? "The source links remain available." : "Connecting to live review sources.";
  }

  function setReviewFilter(filter) {
    reviewState.active = ["all", "google", "pabau"].indexOf(filter) === -1 ? "all" : filter;
    selectAll("[data-paid-v3-review-filter]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-paid-v3-review-filter") === reviewState.active ? "true" : "false");
    });
    renderReviews();
    var grid = select("[data-paid-v3-review-grid]");
    if (grid) grid.scrollLeft = 0;
  }

  function pricingSearchValue(value) {
    return clean(value, 800)
      .toLowerCase()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function initialisePricingModule() {
    var module = select("[data-paid-v3-pricing-module]");
    if (!module || module.getAttribute("data-paid-v3-pricing-ready") === "true") return;
    module.setAttribute("data-paid-v3-pricing-ready", "true");

    var input = select("[data-paid-v3-pricing-search]", module);
    var providerButtons = selectAll("[data-paid-v3-pricing-provider]", module);
    var cards = selectAll("[data-paid-v3-price-option]", module);
    var groups = selectAll("[data-paid-v3-price-group]", module);
    var meta = select("[data-paid-v3-pricing-meta]", module);
    var showAll = select("[data-paid-v3-pricing-show-all]", module);
    var viewControl = select("[data-paid-v3-pricing-view-control]", module);
    var viewButtons = selectAll("[data-paid-v3-pricing-view]", module);
    var viewCount = select("[data-paid-v3-pricing-view-count]", module);
    var activeProvider = "all";
    var completeView = false;
    var expandedGroup = groups.find(function (group) {
      var toggle = select("[data-paid-v3-price-group-toggle]", group);
      return toggle && toggle.getAttribute("aria-expanded") === "true";
    });
    var directlyBookableGroup = visitPlannerEnabled ? groups.find(function (group) {
      return Boolean(select("[data-paid-v3-visit-add]", group));
    }) : null;
    var focusedGroup = directlyBookableGroup || expandedGroup || groups[0];
    var providerNote = module.hasAttribute("data-paid-v3-pricing-provider-note")
      ? clean(module.getAttribute("data-paid-v3-pricing-provider-note"), 160)
      : "Doctor options appear first";

    if (!input || !cards.length || !groups.length || !meta || (!showAll && !viewButtons.length)) return;

    function setGroupOpen(group, open) {
      var toggle = select("[data-paid-v3-price-group-toggle]", group);
      var panel = select("[data-paid-v3-price-group-panel]", group);
      if (toggle) toggle.setAttribute("aria-expanded", String(open));
      if (panel) panel.hidden = !open;
    }

    function updatePricingView() {
      var query = pricingSearchValue(input.value);
      var matches = cards.filter(function (card) {
        var providerMatch = activeProvider === "all" || card.getAttribute("data-paid-v3-price-provider") === activeProvider;
        var searchText = pricingSearchValue(card.getAttribute("data-paid-v3-price-search") || card.textContent);
        return providerMatch && (!query || searchText.indexOf(query) !== -1);
      });

      cards.forEach(function (card) { card.hidden = true; });
      matches.forEach(function (card) { card.hidden = false; });

      var visibleGroups = groups.filter(function (group) {
        var visibleCards = selectAll("[data-paid-v3-price-option]", group).filter(function (card) { return !card.hidden; });
        var count = select("[data-paid-v3-price-group-count]", group);
        group.hidden = visibleCards.length === 0;
        if (count) count.textContent = visibleCards.length + (visibleCards.length === 1 ? " option" : " options");
        return visibleCards.length > 0;
      });

      if (query || completeView) {
        visibleGroups.forEach(function (group) { setGroupOpen(group, true); });
      } else {
        var current = visibleGroups.indexOf(focusedGroup) !== -1 ? focusedGroup : visibleGroups[0];
        focusedGroup = current || focusedGroup;
        visibleGroups.forEach(function (group) { setGroupOpen(group, group === current); });
      }

      var providerLabel = activeProvider === "all" ? "" : " " + activeProvider;
      if (viewButtons.length && matches.length) {
        meta.textContent = completeView
          ? "Showing all " + matches.length + providerLabel + (matches.length === 1 ? " price" : " prices")
          : matches.length + providerLabel + (matches.length === 1 ? " price available" : " prices available") + " across " + visibleGroups.length + (visibleGroups.length === 1 ? " section" : " sections");
      } else {
        meta.textContent = matches.length
          ? matches.length + providerLabel + (matches.length === 1 ? " option" : " options") + " across " + visibleGroups.length + (visibleGroups.length === 1 ? " area" : " areas") + (activeProvider === "all" && providerNote ? " · " + providerNote : "")
          : "No matching" + providerLabel + " pricing options";
      }

      if (showAll) {
        showAll.hidden = Boolean(query) || visibleGroups.length <= 1;
        showAll.textContent = completeView ? "Return to one area at a time" : "View complete list (" + matches.length + ")";
        showAll.setAttribute("aria-expanded", String(completeView));
      }

      if (viewControl) viewControl.hidden = Boolean(query) || visibleGroups.length <= 1;
      if (viewCount) viewCount.textContent = String(matches.length);
      viewButtons.forEach(function (button) {
        var requestedView = button.getAttribute("data-paid-v3-pricing-view");
        button.setAttribute("aria-pressed", String(requestedView === (completeView ? "all" : "area")));
      });
      module.setAttribute("data-paid-v3-pricing-view-mode", completeView ? "all" : "area");
    }

    input.addEventListener("input", updatePricingView);
    providerButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeProvider = button.getAttribute("data-paid-v3-pricing-provider") || "all";
        providerButtons.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", String(candidate === button));
        });
        updatePricingView();
      });
    });

    groups.forEach(function (group) {
      var toggle = select("[data-paid-v3-price-group-toggle]", group);
      if (!toggle) return;
      toggle.addEventListener("click", function () {
        var queryActive = Boolean(pricingSearchValue(input.value));
        if (queryActive) {
          setGroupOpen(group, true);
          return;
        }
        if (completeView) {
          focusedGroup = group;
          completeView = false;
          updatePricingView();
          try { toggle.focus({ preventScroll: true }); } catch (error) { toggle.focus(); }
          return;
        }
        var willOpen = toggle.getAttribute("aria-expanded") !== "true";
        if (willOpen) focusedGroup = group;
        if (!completeView) {
          groups.forEach(function (candidate) {
            setGroupOpen(candidate, candidate === group && willOpen);
          });
          return;
        }
        setGroupOpen(group, willOpen);
      });
    });

    if (showAll) {
      showAll.addEventListener("click", function () {
        completeView = !completeView;
        updatePricingView();
      });
    }

    viewButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        completeView = button.getAttribute("data-paid-v3-pricing-view") === "all";
        updatePricingView();
        try {
          button.focus({ preventScroll: true });
        } catch (_error) {
          button.focus();
        }
      });
    });

    updatePricingView();
  }

  function visitClinicUrl(value, includeAttribution) {
    var url;
    try { url = new URL(clean(value, 24000), window.location.href); } catch (_) { return ""; }
    if (url.protocol !== "https:") return "";
    var host = url.hostname.toLowerCase();
    if (host !== "drsknn.uk" && host !== "www.drsknn.uk") return "";
    if (!policySafe(url.href)) return "";
    if (includeAttribution) {
      var attribution = readAttribution();
      Object.keys(attribution).forEach(function (key) {
        if (!url.searchParams.has(key)) url.searchParams.set(key, attribution[key]);
      });
    }
    return url.toString();
  }

  function finaliseVisitUrl(value) {
    var safe = visitClinicUrl(value, false);
    if (!safe) return "";
    var decorated = decorateTrackedUrl(safe);
    var finalUrl = visitClinicUrl(decorated, false);
    if (!finalUrl || finalUrl.length > VISIT_HANDOFF_MAX_URL) return "";
    return finalUrl;
  }

  function canonicalVisitBookingUrl(value, serviceId, catalogueKey, roleKey) {
    var safe = visitClinicUrl(value, false);
    if (!safe) return "";
    var source = new URL(safe);
    var sourceService = String(source.searchParams.get("service_id") || source.searchParams.get("sid") || "").replace(/\D/g, "");
    var sid = String(serviceId || "").replace(/\D/g, "");
    var locationId = String(source.searchParams.get("loc") || "").replace(/\D/g, "");
    var employeeId = String(source.searchParams.get("emp") || "").replace(/\D/g, "");
    var categoryId = String(source.searchParams.get("category_id") || "").replace(/\D/g, "");
    if (!sid || sourceService !== sid || source.searchParams.get("direct") !== "1" || source.searchParams.get("book") !== "1") return "";
    if (!locationId || !employeeId) return "";
    var url = new URL("https://www.drsknn.uk/kiosk");
    url.searchParams.set("direct", "1");
    url.searchParams.set("sid", sid);
    url.searchParams.set("service_id", sid);
    url.searchParams.set("selected_service_ids", sid);
    url.searchParams.set("loc", locationId);
    url.searchParams.set("emp", employeeId);
    url.searchParams.set("book", "1");
    if (categoryId) url.searchParams.set("category_id", categoryId);
    url.searchParams.set("provider_role", roleKey === "practitioner" ? "qualified_practitioner" : roleKey);
    url.searchParams.set("booking_mode", "direct_service");
    url.searchParams.set("pricing_key", catalogueKey);
    return visitClinicUrl(url.toString(), false);
  }

  function paidVisitDirectUrl(item) {
    var safe = item && visitClinicUrl(item.bookingUrl, false);
    if (!safe) return "";
    var url = new URL(safe);
    url.searchParams.set("landing_source", "drsknn_com_paid_v3_preview");
    url.searchParams.set("campaign", configuredText("data-campaign", "paid_v3_preview", 160));
    url.searchParams.set("landing_page", configuredText("data-page-handle", "paid_v3_preview", 160));
    url.searchParams.set("intent_id", configuredText("data-intent-id", "consultation", 160));
    url.searchParams.set("pricing_key", item.catalogueKey);
    url.searchParams.set("funnel_stage", "paid_v3_visit_browser_direct");
    url.searchParams.set("treatment_area", item.title);
    return finaliseVisitUrl(url.toString());
  }

  function visitRole(value) {
    var role = clean(value, 80).toLowerCase().replace(/[\s-]+/g, "_");
    if (role.indexOf("doctor") !== -1) return { key: "doctor", label: "Doctor" };
    if (role.indexOf("nurse") !== -1) return { key: "nurse", label: "Nurse" };
    if (role.indexOf("practitioner") !== -1 || role.indexOf("qualified") !== -1) {
      return { key: "practitioner", label: "Practitioner" };
    }
    return null;
  }

  function visitPriceCopy(value) {
    if (typeof value === "string") return policySafe(value) ? clean(value, 320) : "";
    if (!value || typeof value !== "object") return "";
    var parts = [];
    var single = policySafe(value.single) ? clean(value.single, 40) : "";
    var subscription = policySafe(value.subscription) ? clean(value.subscription, 40) : "";
    if (single && single !== "—") parts.push("Single " + single);
    if (subscription && subscription !== "—") parts.push("Subscription " + subscription + " per month");
    return parts.join(" · ");
  }

  function normaliseVisitItem(raw) {
    if (!raw || typeof raw !== "object") return null;
    var serviceId = String(raw.serviceId || raw.service_id || raw.id || "").replace(/\D/g, "").slice(0, 12);
    var title = clean(raw.title, 180);
    var role = visitRole(raw.role || raw.providerLabel || raw.provider_label);
    var catalogueKey = clean(raw.catalogueKey || raw.catalogue_key || "", 80).toLowerCase().replace(/[^a-z0-9_-]/g, "");
    var duration = Math.max(15, Math.min(240, Number(raw.duration || raw.durationMinutes || raw.duration_minutes) || 30));
    var bookingUrl = canonicalVisitBookingUrl(
      raw.bookingUrl || raw.booking_url || "", serviceId, catalogueKey, role && role.key
    );
    var prices = visitPriceCopy(raw.prices);
    var policyCopy = [serviceId, title, role && role.label, catalogueKey, bookingUrl, prices].join(" ");
    if (
      !serviceId || !title || !role || !catalogueKey || !VISIT_SAFE_FAMILY_KEYS[catalogueKey] ||
      !bookingUrl || !policySafe(policyCopy)
    ) return null;
    return {
      id: serviceId,
      serviceId: serviceId,
      catalogueKey: catalogueKey,
      title: title,
      role: role.label,
      roleKey: role.key,
      duration: duration,
      bookingUrl: bookingUrl,
      prices: prices || "Price confirmed before treatment"
    };
  }

  function verifiedVisitItem(item) {
    if (!item || !visitCatalogue || !VISIT_SAFE_FAMILY_KEYS[item.catalogueKey]) return null;
    var family = visitCatalogue.find(function (candidate) {
      return candidate.key === item.catalogueKey;
    });
    if (!family) return null;
    return family.options.find(function (candidate) {
      return candidate.id === item.id &&
        candidate.roleKey === item.roleKey &&
        candidate.bookingUrl === item.bookingUrl;
    }) || null;
  }

  function loadVisitSelections() {
    if (!visitPlannerEnabled) return Promise.resolve([]);
    try { window.localStorage.removeItem(visitStorageKey); } catch (_) {}
    var stored = [];
    try { stored = JSON.parse(window.sessionStorage.getItem(visitStorageKey) || "[]"); } catch (_) {}
    if (!Array.isArray(stored)) stored = [];
    var seen = {};
    var candidates = stored.map(normaliseVisitItem).filter(function (item) {
      if (!item || seen[item.id]) return false;
      seen[item.id] = true;
      return true;
    }).slice(0, visitMaxItems);
    visitSelections = [];
    return loadVisitCatalogue().then(function () {
      var verifiedSeen = {};
      visitSelections = candidates.map(verifiedVisitItem).filter(function (item) {
        if (!item || verifiedSeen[item.id]) return false;
        verifiedSeen[item.id] = true;
        return true;
      }).slice(0, visitMaxItems);
      saveVisitSelections();
      renderVisitState(false);
      return visitSelections;
    }).catch(function () {
      visitSelections = [];
      renderVisitState(false);
      return [];
    });
  }

  function saveVisitSelections() {
    try { window.sessionStorage.setItem(visitStorageKey, JSON.stringify(visitSelections)); } catch (_) {}
  }

  function estimatedVisitMinutes() {
    if (!visitSelections.length) return 0;
    var total = visitSelections.reduce(function (sum, item, index) {
      return sum + Number(item.duration || 30) * (index === 0 ? 1 : 0.75);
    }, 0);
    return Math.ceil(total / 15) * 15;
  }

  function selectionFromVisitButton(button) {
    if (!button) return null;
    var actions = button.closest(".paid-v3-pricing-board__option-actions, .paid-v3-visit-browser__actions");
    var direct = actions && actions.querySelector("[data-paid-v3-visit-direct-link]");
    var item = normaliseVisitItem({
      id: button.getAttribute("data-visit-id"),
      serviceId: button.getAttribute("data-visit-service-id"),
      catalogueKey: button.getAttribute("data-visit-catalogue-key"),
      title: button.getAttribute("data-visit-title"),
      role: button.getAttribute("data-visit-role-label") || button.getAttribute("data-visit-role"),
      duration: button.getAttribute("data-visit-duration"),
      bookingUrl: button.getAttribute("data-visit-booking-url") || (direct ? direct.getAttribute("href") : ""),
      prices: button.getAttribute("data-visit-price-copy") || [
        button.getAttribute("data-visit-single-price") && button.getAttribute("data-visit-single-price") !== "—" ? "Single " + button.getAttribute("data-visit-single-price") : "",
        button.getAttribute("data-visit-subscription-price") && button.getAttribute("data-visit-subscription-price") !== "—" ? "Subscription " + button.getAttribute("data-visit-subscription-price") + " per month" : ""
      ].filter(Boolean).join(" · ")
    });
    return verifiedVisitItem(item);
  }

  function ensureVisitUi() {
    if (!visitPlannerEnabled || document.querySelector("[data-paid-v3-visit-modal]")) return;
    var launcher = setAttributes(makeElement("button", "paid-v3-visit__launcher"), {
      type: "button", "data-paid-v3-visit-open": ""
    });
    launcher.hidden = true;
    appendChildren(launcher, [
      makeElement("span", "", "My Visit"),
      setAttributes(makeElement("strong", "", "0"), { "data-paid-v3-visit-count": "" })
    ]);

    var noticeCopy = setAttributes(makeElement("span"), {
      "data-paid-v3-visit-notice-copy": "", role: "status", "aria-live": "polite", "aria-atomic": "true"
    });
    var undo = setAttributes(makeElement("button", "", "Undo"), {
      type: "button", "data-paid-v3-visit-undo": ""
    });
    var notice = appendChildren(setAttributes(makeElement("div", "paid-v3-visit__notice"), {
      "data-paid-v3-visit-notice": ""
    }), [noticeCopy, undo]);
    notice.hidden = true;

    var planHeaderCopy = appendChildren(makeElement("div"), [
      makeElement("span", "", "YOUR VISIT PLAN"),
      setAttributes(makeElement("h2", "", "Plan one clinic visit"), { id: "paid-v3-visit-title" })
    ]);
    var planClose = setAttributes(makeElement("button", "", "×"), {
      type: "button", "data-paid-v3-visit-close": "", "aria-label": "Close visit plan"
    });
    var planHeader = appendChildren(makeElement("header"), [planHeaderCopy, planClose]);
    var planIntro = makeElement(
      "p", "paid-v3-visit__intro",
      "Your selected interests will be carried into the consultation. Consultations are free. A £50 reservation fee secures an appointment with a doctor, nurse or qualified practitioner. Treatment guide prices below are not a charge for this booking."
    );
    var selected = appendChildren(makeElement("div", "paid-v3-visit__selected"), [
      setAttributes(makeElement("strong", "", "0 treatments selected"), { "data-paid-v3-visit-count-copy": "" }),
      makeElement("span", "", "Nothing is booked or charged yet.")
    ]);
    var items = setAttributes(makeElement("div", "paid-v3-visit__items"), { "data-paid-v3-visit-items": "" });

    function addMoreButton(attribute, title, copy) {
      var button = setAttributes(makeElement("button"), { type: "button" });
      button.setAttribute(attribute, "");
      var plus = setAttributes(makeElement("b", "", "+"), { "aria-hidden": "true" });
      var words = appendChildren(makeElement("span"), [
        makeElement("strong", "", title), makeElement("small", "", copy)
      ]);
      return appendChildren(button, [plus, words]);
    }
    var addMore = appendChildren(setAttributes(makeElement("div", "paid-v3-visit__add-more"), {
      role: "group", "aria-label": "Add more to this visit"
    }), [
      addMoreButton("data-paid-v3-visit-add-concerns", "Add another concern", "Choose what you would like help with"),
      addMoreButton("data-paid-v3-visit-add-treatments", "Add more treatments", "Compare current treatment prices")
    ]);
    var summary = appendChildren(makeElement("div", "paid-v3-visit__summary"), [
      makeElement("span", "", "Next step"),
      setAttributes(makeElement("strong", "", "Choose consultation time"), { "data-paid-v3-visit-duration": "" })
    ]);
    var continueButton = appendChildren(setAttributes(makeElement("button", "paid-v3-visit__continue"), {
      type: "button", "data-paid-v3-visit-continue": ""
    }), [
      makeElement("span", "", "Choose a consultation time"),
      makeElement("small", "", "Keep all your selected treatment interests"),
      setAttributes(makeElement("b", "", "→"), { "aria-hidden": "true" })
    ]);
    var clearButton = setAttributes(makeElement("button", "paid-v3-visit__clear", "Clear visit plan"), {
      type: "button", "data-paid-v3-visit-clear": ""
    });
    var planFooter = appendChildren(makeElement("footer"), [continueButton, clearButton]);
    var planDialog = appendChildren(setAttributes(makeElement("section", "paid-v3-visit__dialog"), {
      role: "dialog", "aria-modal": "true", "aria-labelledby": "paid-v3-visit-title", tabindex: "-1"
    }), [planHeader, planIntro, selected, items, addMore, summary, planFooter]);
    var planOverlay = appendChildren(setAttributes(makeElement("div", "paid-v3-visit__overlay"), {
      "data-paid-v3-visit-modal": "", "aria-hidden": "true"
    }), [planDialog]);
    planOverlay.hidden = true;

    var browserHeaderCopy = appendChildren(makeElement("div"), [
      makeElement("span", "", "ADD TO MY VISIT"),
      setAttributes(makeElement("h2", "", "Choose another treatment"), {
        id: "paid-v3-visit-browser-title", "data-paid-v3-visit-browser-title": ""
      })
    ]);
    var browserClose = setAttributes(makeElement("button", "", "×"), {
      type: "button", "data-paid-v3-visit-browser-close": "", "aria-label": "Close treatment browser"
    });
    var browserHeader = appendChildren(makeElement("header"), [browserHeaderCopy, browserClose]);
    var browserCopy = setAttributes(makeElement("p", "", "Choose a treatment family, then compare current exact options."), {
      "data-paid-v3-visit-browser-copy": ""
    });
    var concernChoices = setAttributes(makeElement("div", "paid-v3-visit-browser__concerns"), {
      "data-paid-v3-visit-concerns": "", role: "group", "aria-label": "Choose a concern"
    });
    concernChoices.hidden = true;
    var familySelect = setAttributes(document.createElement("select"), { "data-paid-v3-visit-family": "" });
    var familyLabel = appendChildren(makeElement("label"), [makeElement("span", "", "Treatment family"), familySelect]);
    var searchInput = setAttributes(document.createElement("input"), {
      type: "search", autocomplete: "off", placeholder: "Search treatments…", "data-paid-v3-visit-search": ""
    });
    var searchLabel = appendChildren(makeElement("label"), [makeElement("span", "", "Search treatments"), searchInput]);
    var controls = appendChildren(makeElement("div", "paid-v3-visit-browser__controls"), [familyLabel, searchLabel]);
    var browserStatus = setAttributes(makeElement("p", "paid-v3-visit-browser__status", "Loading current treatment options…"), {
      "data-paid-v3-visit-browser-status": "", role: "status", "aria-live": "polite"
    });
    var browserOptions = setAttributes(makeElement("div", "paid-v3-visit-browser__options"), {
      "data-paid-v3-visit-browser-options": ""
    });
    var browserBody = appendChildren(makeElement("div", "paid-v3-visit-browser__body"), [
      browserCopy, concernChoices, controls, browserStatus, browserOptions
    ]);
    var browserBack = setAttributes(makeElement("button", "", "← Back to My Visit"), {
      type: "button", "data-paid-v3-visit-browser-back": ""
    });
    var browserFooter = appendChildren(makeElement("footer"), [
      browserBack, makeElement("span", "", "Suitability and final price are confirmed before treatment.")
    ]);
    var browserDialog = appendChildren(setAttributes(makeElement("section", "paid-v3-visit-browser"), {
      role: "dialog", "aria-modal": "true", "aria-labelledby": "paid-v3-visit-browser-title", tabindex: "-1"
    }), [browserHeader, browserBody, browserFooter]);
    var browserOverlay = appendChildren(setAttributes(makeElement("div", "paid-v3-visit__overlay"), {
      "data-paid-v3-visit-browser": "", "aria-hidden": "true"
    }), [browserDialog]);
    browserOverlay.hidden = true;

    [launcher, notice, planOverlay, browserOverlay].forEach(function (element) {
      document.body.appendChild(element);
    });
  }

  function hideVisitNotice() {
    if (visitNoticeTimer) window.clearTimeout(visitNoticeTimer);
    visitNoticeTimer = 0;
    visitUndoId = "";
    var notice = document.querySelector("[data-paid-v3-visit-notice]");
    if (notice) notice.hidden = true;
  }

  function showVisitNotice(message, undoId) {
    ensureVisitUi();
    var notice = document.querySelector("[data-paid-v3-visit-notice]");
    if (!notice) return;
    if (visitNoticeTimer) window.clearTimeout(visitNoticeTimer);
    visitUndoId = undoId || "";
    notice.querySelector("[data-paid-v3-visit-notice-copy]").textContent = message;
    notice.querySelector("[data-paid-v3-visit-undo]").hidden = !visitUndoId;
    notice.hidden = false;
    visitNoticeTimer = window.setTimeout(hideVisitNotice, 6500);
  }

  function syncVisitButtons() {
    Array.prototype.slice.call(document.querySelectorAll("[data-paid-v3-visit-add]")).forEach(function (button) {
      if (button.getAttribute("aria-busy") === "true") return;
      var id = String(button.getAttribute("data-visit-service-id") || "").replace(/\D/g, "");
      var selected = visitSelections.some(function (item) { return item.id === id; });
      button.textContent = selected ? "Added to My Visit" : "Add to My Visit";
      button.setAttribute("aria-pressed", String(selected));
    });
  }

  function setVisitAddControlsLoading(loading) {
    Array.prototype.slice.call(document.querySelectorAll("[data-paid-v3-visit-add]")).forEach(function (button) {
      if (loading) {
        if (!button.hasAttribute("data-visit-ready-label")) {
          button.setAttribute("data-visit-ready-label", clean(button.textContent, 80) || "Add to My Visit");
        }
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.textContent = "Preparing My Visit…";
        return;
      }
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.removeAttribute("data-visit-ready-label");
    });
    if (!loading) syncVisitButtons();
  }

  function toggleVisitSelection(button) {
    var item = selectionFromVisitButton(button);
    if (!item) {
      showVisitNotice("This treatment could not be added safely. Please choose it again.", "");
      return;
    }
    var existing = visitSelections.some(function (candidate) { return candidate.id === item.id; });
    if (existing) {
      visitSelections = visitSelections.filter(function (candidate) { return candidate.id !== item.id; });
      saveVisitSelections();
      renderVisitState(false);
      showVisitNotice("“" + item.title + "” removed from My Visit.", "");
      return;
    }
    if (visitSelections.length >= visitMaxItems) {
      showVisitNotice("My Visit is full. Remove a treatment before adding another.", "");
      renderVisitState(true);
      return;
    }
    visitSelections.push(item);
    saveVisitSelections();
    renderVisitState(false);
    showVisitNotice("“" + item.title + "” added to My Visit.", item.id);
  }

  function renderVisitState(open) {
    ensureVisitUi();
    var launcher = document.querySelector("[data-paid-v3-visit-open]");
    var modal = document.querySelector("[data-paid-v3-visit-modal]");
    if (!launcher || !modal) return;
    launcher.hidden = !visitSelections.length;
    launcher.querySelector("[data-paid-v3-visit-count]").textContent = String(visitSelections.length);
    modal.querySelector("[data-paid-v3-visit-count-copy]").textContent = visitSelections.length + (visitSelections.length === 1 ? " treatment selected" : " treatments selected");
    modal.querySelector("[data-paid-v3-visit-duration]").textContent = "Choose consultation time";
    var items = modal.querySelector("[data-paid-v3-visit-items]");
    items.replaceChildren();
    visitSelections.forEach(function (item, index) {
      var row = makeElement("article", "paid-v3-visit__item");
      var number = makeElement("b", "paid-v3-visit__index", String(index + 1));
      number.setAttribute("aria-hidden", "true");
      var copy = makeElement("div");
      copy.appendChild(makeElement("strong", "", item.title));
      copy.appendChild(makeElement("span", "", item.role));
      copy.appendChild(makeElement("small", "", "Treatment guide price: " + item.prices));
      var remove = makeElement("button", "", "Remove");
      remove.type = "button";
      remove.setAttribute("data-paid-v3-visit-remove", item.id);
      remove.setAttribute("aria-label", "Remove " + item.title + " from My Visit");
      row.appendChild(number);
      row.appendChild(copy);
      row.appendChild(remove);
      items.appendChild(row);
    });
    syncVisitButtons();
    if (open === true && visitSelections.length) openVisitModal();
  }

  function closeVisitModal(restoreFocus) {
    var modal = document.querySelector("[data-paid-v3-visit-modal]");
    if (modal) {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
    }
    syncModalState();
    if (restoreFocus !== false && visitReturnFocus && visitReturnFocus.isConnected) {
      try { visitReturnFocus.focus({ preventScroll: true }); } catch (_) { visitReturnFocus.focus(); }
    }
    if (restoreFocus !== false) visitReturnFocus = null;
  }

  function restoreVisitPageFocus(preferred) {
    var target = preferred;
    if (
      !target || !target.isConnected || target.hidden ||
      (typeof target.closest === "function" && target.closest("[hidden]"))
    ) {
      target = root.querySelector("[data-paid-v3-visit-add]");
    }
    visitReturnFocus = null;
    if (target && target.isConnected && typeof target.focus === "function") {
      try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
    }
  }

  function openVisitModal() {
    if (!visitSelections.length) return;
    ensureVisitUi();
    closeTreatmentPicker(false);
    closeVisitBrowser(false);
    var detail = select("[data-paid-v3-detail-modal]");
    var proof = select("[data-paid-v3-proof-modal]");
    if (detail && !detail.hidden) closeDetailModal(false);
    if (proof && !proof.hidden) closeProofModal(false);
    var modal = document.querySelector("[data-paid-v3-visit-modal]");
    if (!modal) return;
    if (
      (!visitReturnFocus || !visitReturnFocus.isConnected) &&
      document.activeElement instanceof HTMLElement &&
      !modal.contains(document.activeElement)
    ) {
      visitReturnFocus = document.activeElement;
    }
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    syncModalState();
    var close = modal.querySelector("[data-paid-v3-visit-close]");
    if (close) close.focus({ preventScroll: true });
  }

  function catalogueFamilies(data) {
    if (!data || data.manager !== "drsknn_paid_v3_visit_catalogue" || !Array.isArray(data.families)) return [];
    return data.families.map(function (family) {
      var familyKey = clean(family && family.catalogueKey, 80).toLowerCase();
      if (!family || !VISIT_SAFE_FAMILY_KEYS[familyKey] || !policySafe(family.label) || !policySafe(familyKey)) return null;
      var options = [];
      (Array.isArray(family.groups) ? family.groups : []).forEach(function (group) {
        (Array.isArray(group.options) ? group.options : []).forEach(function (raw) {
          var item = normaliseVisitItem(raw);
          if (
            item && item.catalogueKey === familyKey &&
            !options.some(function (candidate) { return candidate.id === item.id; })
          ) options.push(item);
        });
      });
      if (!options.length) return null;
      return {
        key: familyKey,
        label: clean(family.label, 100),
        options: options
      };
    }).filter(Boolean);
  }

  function loadVisitCatalogue() {
    if (visitCatalogue) return Promise.resolve(visitCatalogue);
    if (visitCataloguePromise) return visitCataloguePromise;
    var source = clean(root.getAttribute("data-visit-catalogue-src"), 1200);
    var sourceUrl;
    try { sourceUrl = new URL(source, window.location.href); } catch (_) { return Promise.reject(new Error("Invalid catalogue URL")); }
    if (sourceUrl.protocol !== "https:" || !policySafe(sourceUrl.href)) return Promise.reject(new Error("Unsafe catalogue URL"));
    var sourceHost = sourceUrl.hostname.toLowerCase();
    if (sourceHost !== "drsknn.com" && sourceHost !== "www.drsknn.com" && sourceHost !== "cdn.shopify.com") {
      return Promise.reject(new Error("Untrusted catalogue host"));
    }
    visitCataloguePromise = window.fetch(sourceUrl.toString(), { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) throw new Error("Catalogue request failed");
      return response.json();
    }).then(function (data) {
      var families = catalogueFamilies(data);
      if (!families.length) throw new Error("Catalogue validation failed");
      visitCatalogue = families;
      return families;
    }).catch(function (error) {
      visitCataloguePromise = null;
      throw error;
    });
    return visitCataloguePromise;
  }

  function renderVisitBrowser() {
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    if (!browser || !visitCatalogue) return;
    var selectFamily = browser.querySelector("[data-paid-v3-visit-family]");
    var search = browser.querySelector("[data-paid-v3-visit-search]");
    var optionsRoot = browser.querySelector("[data-paid-v3-visit-browser-options]");
    var status = browser.querySelector("[data-paid-v3-visit-browser-status]");
    var familyKey = selectFamily.value;
    var query = pricingSearchValue(search.value);
    var families = familyKey === "all" ? visitCatalogue : visitCatalogue.filter(function (family) { return family.key === familyKey; });
    var matches = [];
    families.forEach(function (family) {
      family.options.forEach(function (item) {
        if (!query || pricingSearchValue(item.title + " " + item.role + " " + item.prices).indexOf(query) !== -1) {
          matches.push({ family: family, item: item });
        }
      });
    });
    optionsRoot.replaceChildren();
    matches.forEach(function (entry) {
      var item = entry.item;
      var card = makeElement("article", "paid-v3-visit-browser__option");
      card.appendChild(makeElement("span", "paid-v3-visit-browser__family", entry.family.label + " · " + item.role));
      card.appendChild(makeElement("h3", "", item.title));
      card.appendChild(makeElement("p", "", item.prices));
      var actions = makeElement("div", "paid-v3-visit-browser__actions");
      var book = makeElement("a", "paid-v3-button paid-v3-button--primary", "Book treatment →");
      book.href = paidVisitDirectUrl(item);
      book.setAttribute("data-paid-v3-visit-direct-link", "");
      book.setAttribute("data-drsknn-paid-cta", "visit-browser-direct");
      book.setAttribute("data-drsknn-no-attribution", "");
      var add = makeElement("button", "paid-v3-button paid-v3-button--visit", "Add to My Visit");
      add.type = "button";
      add.setAttribute("data-paid-v3-visit-add", "");
      add.setAttribute("data-visit-id", item.id);
      add.setAttribute("data-visit-service-id", item.serviceId);
      add.setAttribute("data-visit-catalogue-key", item.catalogueKey);
      add.setAttribute("data-visit-title", item.title);
      add.setAttribute("data-visit-role", item.roleKey);
      add.setAttribute("data-visit-role-label", item.role);
      add.setAttribute("data-visit-duration", String(item.duration));
      add.setAttribute("data-visit-booking-url", item.bookingUrl);
      add.setAttribute("data-visit-price-copy", item.prices);
      add.setAttribute("aria-pressed", "false");
      actions.appendChild(book);
      actions.appendChild(add);
      card.appendChild(actions);
      optionsRoot.appendChild(card);
    });
    status.textContent = matches.length ? "Showing all " + matches.length + (matches.length === 1 ? " matching treatment." : " matching treatments.") : "No matching treatment was found. Try another family or search term.";
    syncVisitButtons();
  }

  function prepareVisitFamilySelect() {
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    var familySelect = browser && browser.querySelector("[data-paid-v3-visit-family]");
    if (!familySelect || !visitCatalogue) return;
    familySelect.replaceChildren();
    var all = makeElement("option", "", "All treatment families");
    all.value = "all";
    familySelect.appendChild(all);
    visitCatalogue.forEach(function (family) {
      var option = makeElement("option", "", family.label + " (" + family.options.length + ")");
      option.value = family.key;
      familySelect.appendChild(option);
    });
    var pageKey = configuredText("data-pricing-key", "", 80).toLowerCase();
    familySelect.value = visitCatalogue.some(function (family) { return family.key === pageKey; }) ? pageKey : "all";
  }

  function renderVisitConcerns() {
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    var choices = browser && browser.querySelector("[data-paid-v3-visit-concerns]");
    if (!choices || !visitCatalogue) return;
    choices.replaceChildren();
    var available = visitCatalogue.map(function (family) { return family.key; });
    VISIT_CONCERNS.forEach(function (concern) {
      if (available.indexOf(concern.family) === -1) return;
      var button = setAttributes(makeElement("button", "", concern.label), {
        type: "button", "data-paid-v3-visit-concern": concern.family
      });
      choices.appendChild(button);
    });
  }

  function closeVisitBrowser(restorePlan) {
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    if (!browser) return;
    var wasOpen = !browser.hidden;
    browser.hidden = true;
    browser.setAttribute("aria-hidden", "true");
    syncModalState();
    if (wasOpen && restorePlan && visitSelections.length) renderVisitState(true);
  }

  function openVisitBrowser(mode) {
    ensureVisitUi();
    closeVisitModal(false);
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    if (!browser) return;
    var concernChoices = browser.querySelector("[data-paid-v3-visit-concerns]");
    var search = browser.querySelector("[data-paid-v3-visit-search]");
    browser.querySelector("[data-paid-v3-visit-browser-title]").textContent = mode === "concerns" ? "What else can we help with?" : "Choose another treatment";
    browser.querySelector("[data-paid-v3-visit-browser-copy]").textContent = mode === "concerns" ? "Choose what you would like help with, then compare the matching current options." : "Choose a treatment family, then compare current exact options.";
    concernChoices.hidden = mode !== "concerns";
    search.value = "";
    browser.hidden = false;
    browser.setAttribute("aria-hidden", "false");
    syncModalState();
    var browserDialog = browser.querySelector('[role="dialog"]');
    if (browserDialog) browserDialog.focus({ preventScroll: true });
    var status = browser.querySelector("[data-paid-v3-visit-browser-status]");
    status.textContent = "Loading current treatment options…";
    loadVisitCatalogue().then(function () {
      prepareVisitFamilySelect();
      renderVisitConcerns();
      concernChoices.hidden = mode !== "concerns";
      renderVisitBrowser();
      var focusTarget = mode === "concerns" ? browser.querySelector("[data-paid-v3-visit-concern]") : search;
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }).catch(function () {
      status.textContent = "The current treatment list could not load. Your existing My Visit choices are safe; close this window and try again.";
      if (browserDialog) browserDialog.focus({ preventScroll: true });
    });
  }

  function visitConsultationUrl() {
    if (!visitSelections.length || visitSelections.length > visitMaxItems) return "";
    // Preserve the existing advertising catalogue boundary. Never silently
    // discard a saved interest to construct a different consultation plan.
    if (!visitSelections.every(function (item) { return Boolean(verifiedVisitItem(item)); })) return "";
    var url = new URL("https://www.drsknn.uk/book/visit");
    var ids = [];
    var locations = [];
    var interests = visitSelections.map(function (item) {
      var interest = { title: clean(item.title, 160), service_id: item.serviceId, role: item.roleKey };
      if (ids.indexOf(item.serviceId) === -1) ids.push(item.serviceId);
      var location = "";
      try {
        var exact = new URL(item.bookingUrl);
        if (/^https:\/\/(?:www\.)?drsknn\.uk$/.test(exact.origin) && !exact.username && !exact.password) {
          location = exact.searchParams.get("loc") || "";
        }
      } catch (_) {}
      locations.push(/^[1-9]\d*$/.test(location) ? location : "");
      return interest;
    });
    url.searchParams.set("source", "paid_v3_visit");
    url.searchParams.set("landing_source", "drsknn_com_paid_v3_preview");
    url.searchParams.set("campaign", configuredText("data-campaign", "paid_v3_preview", 160));
    url.searchParams.set("landing_page", configuredText("data-page-handle", "paid_v3_preview", 160));
    url.searchParams.set("intent_id", configuredText("data-intent-id", "consultation", 160));
    url.searchParams.set("pricing_key", configuredText("data-pricing-key", "consultation", 80));
    url.searchParams.set("funnel_stage", "paid_v3_consultation_plan");
    url.searchParams.set("booking_route", "website_consultation_plan");
    url.searchParams.set("booking_mode", "consultation");
    url.searchParams.set("service_ids", ids.join(","));
    url.searchParams.set("selected_interests", JSON.stringify(interests));
    if (locations[0] && locations.every(function (location) { return location === locations[0]; })) {
      url.searchParams.set("loc", locations[0]);
    }
    return finaliseVisitUrl(url.toString());
  }

  function beginVisitGesture(button, pointerId, x, y) {
    if (!button) return;
    visitAddGesture = { button: button, pointerId: pointerId, x: x, y: y, moved: false };
  }

  function moveVisitGesture(pointerId, x, y) {
    if (!visitAddGesture || visitAddGesture.pointerId !== pointerId) return;
    if (Math.max(Math.abs(x - visitAddGesture.x), Math.abs(y - visitAddGesture.y)) < 10) return;
    visitAddGesture.moved = true;
    visitSuppressedButton = visitAddGesture.button;
    visitSuppressedUntil = Date.now() + 800;
  }

  function finishVisitGesture(pointerId) {
    if (!visitAddGesture || visitAddGesture.pointerId !== pointerId) return;
    if (visitAddGesture.moved) {
      visitSuppressedButton = visitAddGesture.button;
      visitSuppressedUntil = Date.now() + 800;
    }
    visitAddGesture = null;
  }

  function suppressVisitClick(button) {
    var suppress = button === visitSuppressedButton && Date.now() <= visitSuppressedUntil;
    if (suppress) {
      visitSuppressedButton = null;
      visitSuppressedUntil = 0;
    }
    return suppress;
  }

  function visitModalKeydown(event) {
    var visitModal = document.querySelector("[data-paid-v3-visit-modal]");
    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    var active = browser && !browser.hidden ? browser : visitModal && !visitModal.hidden ? visitModal : null;
    if (!active) return;
    if (event.key === "Escape") {
      event.preventDefault();
      if (active === browser) closeVisitBrowser(true);
      else closeVisitModal(true);
      return;
    }
    trapModalFocus(event, active);
  }

  function initialiseVisitPlanner() {
    if (!visitPlannerEnabled) return;
    ensureVisitUi();
    setVisitAddControlsLoading(true);
    loadVisitSelections().then(function () {
      setVisitAddControlsLoading(false);
    });
    renderVisitState(false);

    var browser = document.querySelector("[data-paid-v3-visit-browser]");
    browser.querySelector("[data-paid-v3-visit-family]").addEventListener("change", renderVisitBrowser);
    browser.querySelector("[data-paid-v3-visit-search]").addEventListener("input", renderVisitBrowser);
    document.addEventListener("keydown", visitModalKeydown);

    if ("PointerEvent" in window) {
      document.addEventListener("pointerdown", function (event) {
        if (event.pointerType !== "touch" && event.pointerType !== "pen") return;
        beginVisitGesture(event.target.closest("[data-paid-v3-visit-add]"), event.pointerId, event.clientX, event.clientY);
      }, true);
      document.addEventListener("pointermove", function (event) {
        if (event.pointerType !== "touch" && event.pointerType !== "pen") return;
        moveVisitGesture(event.pointerId, event.clientX, event.clientY);
      }, true);
      document.addEventListener("pointerup", function (event) { finishVisitGesture(event.pointerId); }, true);
      document.addEventListener("pointercancel", function (event) { finishVisitGesture(event.pointerId); }, true);
    }

    document.addEventListener("click", function (event) {
      var add = event.target.closest("[data-paid-v3-visit-add]");
      if (add) {
        event.preventDefault();
        if (suppressVisitClick(add)) {
          event.stopImmediatePropagation();
          return;
        }
        if (!visitCatalogue) {
          setVisitAddControlsLoading(true);
          showVisitNotice("Preparing the current treatment list…", "");
          loadVisitCatalogue().then(function () {
            setVisitAddControlsLoading(false);
            toggleVisitSelection(add);
          }).catch(function () {
            setVisitAddControlsLoading(false);
            showVisitNotice("The current treatment list could not load. Please try again.", "");
          });
          return;
        }
        toggleVisitSelection(add);
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-open]")) {
        event.preventDefault();
        renderVisitState(true);
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-close]")) {
        event.preventDefault();
        closeVisitModal(true);
        return;
      }
      var remove = event.target.closest("[data-paid-v3-visit-remove]");
      if (remove) {
        event.preventDefault();
        var removedId = remove.getAttribute("data-paid-v3-visit-remove");
        var removedButton = root.querySelector('[data-paid-v3-visit-add][data-visit-service-id="' + removedId + '"]');
        visitSelections = visitSelections.filter(function (item) { return item.id !== removedId; });
        saveVisitSelections();
        renderVisitState(false);
        if (visitSelections.length) openVisitModal();
        else {
          closeVisitModal(false);
          restoreVisitPageFocus(removedButton);
        }
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-clear]")) {
        event.preventDefault();
        var clearFocus = root.querySelector('[data-paid-v3-visit-add][aria-pressed="true"]');
        visitSelections = [];
        saveVisitSelections();
        hideVisitNotice();
        renderVisitState(false);
        closeVisitModal(false);
        restoreVisitPageFocus(clearFocus);
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-undo]")) {
        event.preventDefault();
        var undoId = visitUndoId;
        var undoTarget = undoId && (
          document.querySelector('[data-paid-v3-visit-browser]:not([hidden]) [data-paid-v3-visit-add][data-visit-service-id="' + undoId + '"]') ||
          root.querySelector('[data-paid-v3-visit-add][data-visit-service-id="' + undoId + '"]')
        );
        if (visitUndoId) {
          visitSelections = visitSelections.filter(function (item) { return item.id !== visitUndoId; });
          saveVisitSelections();
          renderVisitState(false);
        }
        hideVisitNotice();
        if (undoTarget && undoTarget.isConnected && !undoTarget.closest("[hidden]")) {
          try { undoTarget.focus({ preventScroll: true }); } catch (_) { undoTarget.focus(); }
        } else {
          var activeVisitOverlay = document.querySelector('[data-paid-v3-visit-browser]:not([hidden]), [data-paid-v3-visit-modal]:not([hidden])');
          var activeVisitDialog = activeVisitOverlay && activeVisitOverlay.querySelector('[role="dialog"]');
          if (activeVisitDialog) activeVisitDialog.focus({ preventScroll: true });
          else restoreVisitPageFocus(root.querySelector("[data-paid-v3-visit-add]"));
        }
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-add-concerns]")) {
        event.preventDefault();
        openVisitBrowser("concerns");
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-add-treatments]")) {
        event.preventDefault();
        openVisitBrowser("treatments");
        return;
      }
      var concern = event.target.closest("[data-paid-v3-visit-concern]");
      if (concern) {
        event.preventDefault();
        var concernBrowser = document.querySelector("[data-paid-v3-visit-browser]");
        var concernFamily = concernBrowser && concernBrowser.querySelector("[data-paid-v3-visit-family]");
        var concernSearch = concernBrowser && concernBrowser.querySelector("[data-paid-v3-visit-search]");
        if (concernFamily) concernFamily.value = clean(concern.getAttribute("data-paid-v3-visit-concern"), 80);
        if (concernSearch) concernSearch.value = "";
        renderVisitBrowser();
        var firstOption = concernBrowser && concernBrowser.querySelector("[data-paid-v3-visit-browser-options] .paid-v3-visit-browser__option");
        if (firstOption) firstOption.scrollIntoView({ behavior: "smooth", block: "nearest" });
        return;
      }
      if (event.target.closest("[data-paid-v3-visit-browser-close], [data-paid-v3-visit-browser-back]")) {
        event.preventDefault();
        closeVisitBrowser(true);
        return;
      }
      var continueButton = event.target.closest("[data-paid-v3-visit-continue]");
      if (continueButton) {
        event.preventDefault();
        var url = visitConsultationUrl();
        if (!url) {
          showVisitNotice("Your visit plan needs one valid treatment before continuing.", "");
          return;
        }
        closeVisitModal(false);
        window.location.assign(url);
        return;
      }
      var visitOverlay = event.target.closest("[data-paid-v3-visit-modal]");
      if (visitOverlay && event.target === visitOverlay) {
        closeVisitModal(true);
        return;
      }
      var browserOverlay = event.target.closest("[data-paid-v3-visit-browser]");
      if (browserOverlay && event.target === browserOverlay) closeVisitBrowser(true);
    }, true);
  }

  function jumpToReviews(source, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    }
    setReviewFilter(source === "google" || source === "pabau" ? source : "all");
    var section = select("#paid-v3-reviews");
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function positionConsentControls() {
    var mobile = window.matchMedia("(max-width: 820px)").matches;
    Array.prototype.slice.call(document.querySelectorAll(
      ".iubenda-tp-btn.iubenda-cs-preferences-link"
    )).forEach(function (button) {
      if (mobile) {
        if (
          button.style.getPropertyValue("right") !== "12px" ||
          button.style.getPropertyPriority("right") !== "important"
        ) {
          button.style.setProperty("right", "12px", "important");
        }
        if (
          button.style.getPropertyValue("bottom") !== "calc(82px + env(safe-area-inset-bottom))" ||
          button.style.getPropertyPriority("bottom") !== "important"
        ) {
          button.style.setProperty(
            "bottom", "calc(82px + env(safe-area-inset-bottom))", "important"
          );
        }
        button.setAttribute("data-paid-v3-consent-positioned", "true");
        return;
      }
      if (button.getAttribute("data-paid-v3-consent-positioned") === "true") {
        button.style.removeProperty("right");
        button.style.removeProperty("bottom");
        button.removeAttribute("data-paid-v3-consent-positioned");
      }
    });
  }

  var consentFrame = 0;
  function scheduleConsentPosition() {
    window.cancelAnimationFrame(consentFrame);
    consentFrame = window.requestAnimationFrame(positionConsentControls);
  }

  var consentObserver = new MutationObserver(scheduleConsentPosition);
  consentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style"]
  });

  root.addEventListener("click", function (event) {
    var treatmentPickerTrigger = event.target.closest("[data-paid-v3-treatment-picker-open]");
    if (treatmentPickerTrigger && openTreatmentPicker(treatmentPickerTrigger)) {
      event.preventDefault();
      return;
    }

    if (event.target.closest("[data-paid-v3-treatment-picker-view-full]")) {
      event.preventDefault();
      viewFullPricingOnPage();
      return;
    }

    if (event.target.closest("[data-paid-v3-treatment-picker-close]")) {
      event.preventDefault();
      closeTreatmentPicker(true);
      return;
    }

    var detailTrigger = event.target.closest("[data-paid-v3-detail]");
    if (detailTrigger) {
      event.preventDefault();
      openDetailModal(detailTrigger);
      return;
    }

    if (event.target.closest("[data-paid-v3-detail-close]")) {
      event.preventDefault();
      closeDetailModal();
      return;
    }

    var reviewJump = event.target.closest("[data-paid-v3-review-jump]");
    if (reviewJump) {
      jumpToReviews(reviewJump.getAttribute("data-paid-v3-review-jump"), event);
      return;
    }

    var filter = event.target.closest("[data-paid-v3-review-filter]");
    if (filter) {
      event.preventDefault();
      event.stopPropagation();
      setReviewFilter(filter.getAttribute("data-paid-v3-review-filter"));
      return;
    }

    var previous = event.target.closest("[data-paid-v3-proof-prev]");
    if (previous) {
      event.preventDefault();
      scrollProof(-1);
      return;
    }

    var next = event.target.closest("[data-paid-v3-proof-next]");
    if (next) {
      event.preventDefault();
      scrollProof(1);
      return;
    }

    var open = event.target.closest("[data-paid-v3-proof-open]");
    if (open) {
      event.preventDefault();
      openProofModal(Number(open.getAttribute("data-paid-v3-proof-open") || 0), open);
      return;
    }

    if (event.target.closest("[data-paid-v3-proof-close]")) {
      event.preventDefault();
      closeProofModal();
      return;
    }

    if (event.target.closest("[data-paid-v3-proof-modal-prev]")) {
      event.preventDefault();
      setProofModal(proofModalIndex - 1);
      return;
    }

    if (event.target.closest("[data-paid-v3-proof-modal-next]")) {
      event.preventDefault();
      setProofModal(proofModalIndex + 1);
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    var treatmentPicker = select("[data-paid-v3-treatment-picker]");
    if (treatmentPicker && !treatmentPicker.hidden) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeTreatmentPicker(true);
      }
      if (event.key === "Tab") trapModalFocus(event, treatmentPicker);
      return;
    }
    var detailModal = select("[data-paid-v3-detail-modal]");
    if (detailModal && !detailModal.hidden) {
      if (event.key === "Escape") closeDetailModal();
      if (event.key === "Tab") trapModalFocus(event, detailModal);
      return;
    }
    var modal = select("[data-paid-v3-proof-modal]");
    if (!modal || modal.hidden) return;
    if (event.key === "Escape") closeProofModal();
    if (event.key === "Tab") trapModalFocus(event, modal);
    if (event.key === "ArrowLeft") setProofModal(proofModalIndex - 1);
    if (event.key === "ArrowRight") setProofModal(proofModalIndex + 1);
  });

  var proofViewport = select("[data-paid-v3-proof-viewport]");
  if (proofViewport) {
    var scrollFrame = 0;
    proofViewport.addEventListener("scroll", function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(updateProofPosition);
    }, { passive: true });
  }
  var reviewGrid = select("[data-paid-v3-review-grid]");
  if (reviewGrid) {
    var syncReviewAccessibility = function () {
      var mobileReviewTrack = window.matchMedia("(max-width: 560px)").matches;
      if (mobileReviewTrack) {
        reviewGrid.setAttribute("tabindex", "0");
        reviewGrid.setAttribute("aria-label", "Patient reviews. Swipe or use the arrow keys to read more.");
      } else {
        reviewGrid.removeAttribute("tabindex");
        reviewGrid.setAttribute("aria-label", "Patient reviews");
      }
    };
    syncReviewAccessibility();
    reviewGrid.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      if (!window.matchMedia("(max-width: 560px)").matches) return;
      event.preventDefault();
      reviewGrid.scrollBy({
        left: (event.key === "ArrowRight" ? 1 : -1) * Math.max(1, reviewGrid.clientWidth - 24),
        behavior: "smooth"
      });
    });
    window.addEventListener("resize", syncReviewAccessibility, { passive: true });
    reviewGrid.addEventListener("scroll", scheduleReviewLayout, { passive: true });
    window.addEventListener("resize", scheduleReviewLayout, { passive: true });
    window.addEventListener("pagehide", pauseReviewLayout);
    window.addEventListener("pageshow", resumeReviewLayout);
    if (document.fonts) {
      if (document.fonts.ready && typeof document.fonts.ready.then === "function") {
        document.fonts.ready.then(scheduleReviewLayout, function () {});
      }
      if (typeof document.fonts.addEventListener === "function") {
        document.fonts.addEventListener("loadingdone", scheduleReviewLayout);
      }
    }
  }
  window.addEventListener("resize", updateProofPosition, { passive: true });
  window.addEventListener("resize", scheduleConsentPosition, { passive: true });

  decorateAttributionLinks();
  initialisePricingModule();
  initialiseVisitPlanner();
  positionConsentControls();
  renderProof();
  renderReviews();
  loadGoogleReviews();
  loadPabauReviews();
})();
